/*
*###############################################################################
*Module Name                   : VoucherGRNController.js                     #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Friday, October 12th 2021, 3:20:00 pm          #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
const getSupplierDets = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Supplier/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getLocationDets = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherGroup = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGroup/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

// Voucher Group save method
const setVoucherSave = async (
  strVoucherCode,
  strVoucherDate,
  strSetupLoc,
  strCompanyCode,
  strSupplier,
  strLocation,
  strRemarks1,
  strRemarks2,
  strRefNo,
  strBatchNo,
  dbSellingAmount,
  dbGrossAmount,
  dbDiscountPer,
  dbItexAmount,
  dbETaxAmount,
  dbAddAmount,
  dbDedAmount,
  dbNetAmount,
  strCreateBy,
  menuCode,
  LogCompanyCode,
  LocationCode,
  Reason,
  VCPODETAILS,
  VoucherPoTaxDet
) => {
  const authToken = localStorage.getItem("authToken")
  var myHeaders = new Headers()
  myHeaders.append("Authorization", `Bearer ${authToken}`)
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strType: 'VPO',
    strRunNo: strVoucherCode == "" ? "NAN" : strVoucherCode,
    dtTxnDate: strVoucherDate == "" ? "1900-01-01" : strVoucherDate,
    dtTxnTime: strVoucherDate == "" ? "1900-01-01" : strVoucherDate,
    strSetupLoc: strSetupLoc,
    strComCode: strCompanyCode,
    strLocCode: strLocation,
    strSupCode: strSupplier,
    strRef1: strRemarks1,
    strRef2: strRemarks2,
    strRefNo: strRefNo,
    strBatchNo: strBatchNo,
    dbSellingAmount: dbSellingAmount,
    dbGrossAmount: dbGrossAmount,
    dbDiscountPer: dbDiscountPer,
    dbItexAmount: dbItexAmount,
    dbETaxAmount: dbETaxAmount,
    dbAddAmount: dbAddAmount,
    dbDedAmount: dbDedAmount,
    dbNetAmount: dbNetAmount,
    intHedProcess: 1,
    intHedCancelled: 0,
    dtCancellDate: '1900-01-01',
    strCancelldUser: '',
    dbPrintCount: 0,
    intHedFullyUsed: 1,
    intExport: 0,
    strExportBatch: '',
    strCreateBy: strCreateBy,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
    strReason: Reason,
    VCGRNDETAILS: VCPODETAILS,
    VCGRNDETAILSTAX: VoucherPoTaxDet
  })

  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}VoucherGRN`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}
const getVoucherPOSearch = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/PendingPo`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherPOHeader = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/search/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

// const getVoucherPendingPOHeader = async id => {
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")
//   var data = []
//   var requestOptions = {
//     method: "GET",
//     headers: {
//       "Authorization": `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   }
//   await fetch(`${ApiURL}VoucherPO/searchPending/${id}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       data = result.data
//     })
//     .catch(error => console.log("error", error))
//   return data
// }

const getVoucherPendingPOHeader = async (id) => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`,
    },
    redirect: "follow",
  };

  try {
    const response = await fetch(`${ApiURL}VoucherPO/searchPending/${id}`, requestOptions);
    const result = await response.json();

    if (result.success) {
      return { success: true, data: result.data };
    }
    return { success: false, data: [] };

  } catch (error) {
    console.error("Error:", error);
    return { success: false, error: error.message }; // Return an error object
  }
};


const getVoucherGRNSearch = async LocationCode => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGRN/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherGRNHeader = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var success = false
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGRN/search/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
      success = result.success
    })
    .catch(error => console.log("error", error))
  return { data, success }
}


export {
  getLocationDets,
  getSupplierDets,
  getVoucherGroup,
  setVoucherSave,
  getVoucherPOSearch,
  getVoucherPOHeader,
  getVoucherGRNSearch,
  getVoucherGRNHeader,
  getVoucherPendingPOHeader
}